/**
 * @date: 12/11/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {forwardRef, useEffect, useState} from "react";
import ShowMessage from "../utils/show-message";
import {Alert, Button, Container, Pagination} from '@mui/material';
import './UserList.css';
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import ShowUsersAsList from "./ShowUsersAsList";
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {isMasterAdmin} from "../utils/portal-helper";
import {ApiUrl} from "../utils/portal-urls";
import OrganizationUsersSearchPanel from "./OrganizationUsersSearchPanel";
import {useParams} from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import OrganizationUserAddDialog from "./OrganizationUserAddDialog";
import OrganizationUserTokenLinkDialog from "./OrganizationUserTokenLinkDialog";
import Slide from "@mui/material/Slide";

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    titleButton: {
        fontSize: 15,
        float: 'right'
    },
    dialogUrl: {
        borderStyle: "solid",
        borderWidth: "thin",
        borderColor: "#d3d3d3",
        textAlign: "center",
        padding: "5px"
    }

}));


export default function OrganizationUsersHome(props) {
    const {user, organization} = props.account;
    const classes = useStyles();
    const account = props.account;
    const getParameters = getQueryParams();
    const { orgId } = useParams();

    console.log('OrganizationUsersHome' , user, organization);
    // console.table(user);
    // if (isMasterAdmin(user)){
    //     window.location.href = "/";
    //     return "";
    // }

    // const organizationId = organization && organization.id || orgId;

    const [tableListLoading, setTableListLoading] = useState(false);
    const [queryLoading, setQueryLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [refresh, setRefresh] = useState(new Date().getTime());
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);

    const [page, setPage] = useState(getParameters.page ? parseInt(getParameters.page) : 0);
    const [msg, setMsg] = useState({});
    const [pageResult, setPageResult] = useState(null);
    const [slideDialogOpen, setSlideDialogOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [tokenLink, setTokenLink] = useState();
    const [newUser, setNewUser] = useState();


    let organizationName;
    if (organization && organization.name){
        organizationName = organization.name;
    } else if (query.orgName){
        organizationName = query.orgName;
    } else {
        organizationName = null;
    }

    useEffect(() => {
        console.log('page changed or refresh, useEffect fetch: ', query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0){
            // changed search criteria, reset to page 0
            setPage(0);
        } else {
            fetchPage(query, page);
        }
    }, [query, page, refresh]);

    const handleTokenLinkDialogClose = () => {
        setSlideDialogOpen(false);
    }

    const fetchPage = async (query, page) => {
        setTableListLoading("Loading");
        const queryAnd = query ? `&${query}` : "";
        const url = ApiUrl.Users.query.getPath(query, page, account);
        fetch(url)
            .then(handleHttpResponse)
            .catch( (err) => {
                console.error('failed to fetch certificates', err);
                setTableListLoading(false);
                // setLoading(false);
                if (err){
                    setMsg({error: err});
                }
            }).then ( (res) => {
                setTableListLoading(false);
                // setLoading(false);
                console.log('query adts result', res);
                setCurrentViewingQuery(query);
                setPageResult(res);
                // if (res.info && props.onServerInfoUpdated){
                //     props.onServerInfoUpdated(res.info);
                // }
                // if (res.data){
                //     setPageResult(res.data);
                // }
            });
    }

    return (
        <Container className={classes.container} maxWidth='xl'>
            {pageResult?.content &&
                <OrganizationUserAddDialog open={dialogOpen} close={(c) => setDialogOpen(c)}
                                           setSlideDialogOpen={(o) => setSlideDialogOpen(o)} user={user} setTokenLink={(t) => setTokenLink(t)} setNewUser={(u) => setNewUser(u)}
                                           onRefresh={(v) => setRefresh(v)} pageResult={pageResult.content}
                />
            }
            <OrganizationUserTokenLinkDialog open={slideDialogOpen} close={(c) => setSlideDialogOpen(c)} newUser={newUser} tokenLink={tokenLink}/>


            <h3 className='title'>
                Users
                <Button variant="contained" sx={{float: "right"}} onClick={() => setDialogOpen(true)}><AddIcon /> Add New User</Button>
            </h3>
            {/*<ExportCertificateAsKeystore id='abc' />*/}
            <ShowMessage msg={msg} />
            {/*<hr/>*/}
            <OrganizationUsersSearchPanel onQueryStringChanged={(q) => setQuery(q)} onRefresh={(v) => setRefresh(v)} showOrgContact={isMasterAdmin(account.user)} />
            <hr/>

            <div className='users-list-wrapper'>
                {pageResult && <Alert severity="info" icon={false} >
                    Found {pageResult.totalElements} users(s).
                    {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}

                </Alert>}

                {/*Testing*/}
                {/*{pageResult && pageResult.length > 0 && <ShowUsersAsList myself={user} users={pageResult} setRefresh={(c) => setRefresh(c)}/>}*/}

                { pageResult && pageResult.content && pageResult.content.length > 0 && <div>
                    <ShowUsersAsList myself={user} users={pageResult.content} setRefresh={(v) => setRefresh(v)} title="Edit"/>
                    {/*<ShowUsersAsList myself={user} users={pageResult.content} handleEditUser={handleEditUser}/>*/}

                    <br/>
                    {pageResult.totalPages > 1 &&
                        <Pagination page={page + 1} count={pageResult.totalPages} variant={"outlined"} color={"primary"}
                                    onChange={(e, newPage) => setPage(newPage - 1)} />
                    }
                </div>

                }

                {/*{pageResult && <Alert severity="info" icon={false} >*/}
                {/*    Found {pageResult.totalElements} users(s).*/}
                {/*    {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}*/}

                {/*</Alert>}*/}
            </div>



            <Backdrop className={classes.backdrop} open={tableListLoading || queryLoading ? true : false} >
                <CircularProgress color={"inherit"} />
                {tableListLoading && <> {tableListLoading} ... </>}
                {queryLoading && <> {queryLoading} ... </>}
            </Backdrop>
        </Container>
    );
}
